import request from '@/utils/request'

// 分页查询房间信息
export function getPageList(params) {
  return request({
    url: '/hrApi/room',
    method: 'get',
    params: params
  })
}

// 获取房间列表
export function getList(params) {
  return request({
    url: '/hrApi/room/list',
    method: 'get',
    params: params
  })
}

// 新增或编辑房间
export function saveOrUpdateData(data) {
  return request({
    url: '/hrApi/room',
    method: 'post',
    data: data
  })
}

// 删除房间
export function deleteData(id) {
  return request({
    url: '/hrApi/room/' + id,
    method: 'delete'
  })
}

// 导出
export function exportData(params) {
  return request({
    url: '/hrApi/room/export',
    method: 'get',
    params: params,
    responseType: 'blob'
  })
}



// WEBPACK FOOTER //
// ./src/api/room.js